// @todo has gotten messy
import event from '../../../event'

function OAuthRequest (authUris) {
  function foo (req, next) {
    // not a refresh token route
    let isGeneralAPIcall = true
    let isAuthRefreshRoute = req.url.match('/refresh-token')
    let isLoginAttempt = req.url.match('/authenticate')
    /*
     If your req.url is to a /oauth || auth endpoint
     then we shouldn't add any headers.
     If an API request, we should
     add Authourization header
     */
    authUris.forEach(uri => {
      isGeneralAPIcall = (req.url.match(uri) ? false : isGeneralAPIcall)
    })
    if (isGeneralAPIcall) {
      this.dispatch('authorization/refreshToken')
        .then((res) => {
          this.dispatch('authentication/refreshToken')
            .then((res) => {
              req.headers.set('Authorization', 'Bearer ' + this.getters['authorization/accessToken'])
              req.headers.set('X-Authentication', this.getters['authentication/token'])
              next()
            }).catch((err) => {
              // couldn't authorize so send error message @todo
              console.log(err)
              next(req.respondWith({}, {
                status: 401,
                statusText: 'Unauthorized'
              }))
              event.$emit('logout')
            })
        }).catch((err) => {
          // couldn't authorize so send error message @todo
          console.log(err)
          next(req.respondWith({}, {
            status: 401,
            statusText: 'Unauthorized'
          }))
          event.$emit('logout')
        })
    } else if (isLoginAttempt) {
      this.dispatch('authorization/refreshToken')
        .then((res) => {
          req.headers.set('Authorization', 'Bearer ' + this.getters['authorization/accessToken'])
          req.headers.set('X-Authentication', this.getters['authentication/token'])
          next()
        }).catch((err) => {
          // couldn't authorize so send error message @todo
          console.log(err)
          next(req.respondWith({}, {
            status: 401,
            statusText: 'Unauthorized'
          }))
          event.$emit('logout')
        })
    } else if (isAuthRefreshRoute) {
      req.headers.set('Authorization', 'Bearer ' + this.getters['authorization/accessToken'])
      req.headers.set('X-Authentication', this.getters['authentication/token'])
      next()
    } else {
      // is oauth token refresh route
      next()
    }
  }
  return foo
}

export default OAuthRequest



// WEBPACK FOOTER //
// ./src/modules/authorization/middleware/OAuthRequest.js